import i18n from "i18next";

import { mutateData } from "@/core/api/api-methods";
import { endpoints } from "@/core/api/endpoints";
import { useSessionStore } from "@/core/stores/session.store";
import { getDeviceHeaders, getDeviceId } from "@/core/utils/func/deviceHeaders";
import { logger } from "@/core/utils/func/logger";

function toNotificationLanguage(lang: string): "FR" | "EN" | "ZH" {
  const code = lang.slice(0, 2).toUpperCase();
  if (code === "EN" || code === "ZH") return code;
  return "FR";
}

/**
 * Enregistre ou rafraîchit l'appareil PUSH (guide v1.4).
 * Destinataire = claim `sub` du JWT — ne pas l'envoyer dans le corps.
 */
export async function registerNotificationDevice(fcmToken: string): Promise<void> {
  const headers = getDeviceHeaders();
  const deviceName = headers["x-device-name"]?.trim();
  const appVersion = headers["x-app-version"]?.trim();

  await mutateData({
    url: endpoints.notification.devices.add,
    method: "POST",
    reqBody: {
      fcmToken,
      deviceId: getDeviceId(),
      platform: "WEB",
      ...(deviceName ? { deviceName } : {}),
      ...(appVersion ? { appVersion } : {}),
      language: toNotificationLanguage(i18n.language || "fr"),
    },
  });
}

/**
 * Désenregistre l'appareil courant. Best-effort : 204 même si inconnu ;
 * toute erreur est ignorée (logout ne doit pas rester bloqué).
 */
export async function unregisterNotificationDeviceBestEffort(): Promise<void> {
  if (!useSessionStore.getState().accessToken) return;
  try {
    await mutateData({
      url: endpoints.notification.devices.byId(getDeviceId()),
      method: "DELETE",
    });
  } catch (error) {
    logger.warn("Désenregistrement FCM ignoré.", {
      prefix: "FCM",
      data: error,
    });
  }
}
